// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#nav a.router-link-exact-active[data-v-d1a7e442] {\n  color: white;\n}", ""]);
// Exports
module.exports = exports;
